export default __webpack_public_path__ + "static/media/DeleteIcon-blue.85b06c14.svg";